/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type StartPlatformMCPOnboardingSetupSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type StartPlatformMCPOnboardingSetupRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type StartPlatformMCPOnboardingSetupSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const StartPlatformMCPOnboardingSetupSecurity$outboundSchema:
  z.ZodMiniType<
    StartPlatformMCPOnboardingSetupSecurity$Outbound,
    StartPlatformMCPOnboardingSetupSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function startPlatformMCPOnboardingSetupSecurityToJSON(
  startPlatformMCPOnboardingSetupSecurity:
    StartPlatformMCPOnboardingSetupSecurity,
): string {
  return JSON.stringify(
    StartPlatformMCPOnboardingSetupSecurity$outboundSchema.parse(
      startPlatformMCPOnboardingSetupSecurity,
    ),
  );
}

/** @internal */
export type StartPlatformMCPOnboardingSetupRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const StartPlatformMCPOnboardingSetupRequest$outboundSchema:
  z.ZodMiniType<
    StartPlatformMCPOnboardingSetupRequest$Outbound,
    StartPlatformMCPOnboardingSetupRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function startPlatformMCPOnboardingSetupRequestToJSON(
  startPlatformMCPOnboardingSetupRequest:
    StartPlatformMCPOnboardingSetupRequest,
): string {
  return JSON.stringify(
    StartPlatformMCPOnboardingSetupRequest$outboundSchema.parse(
      startPlatformMCPOnboardingSetupRequest,
    ),
  );
}
